import React from "react";
import "../styles/layout.css";

const ReusableHeader = ({ title, children }) => {
  return (
    <div className="reusable-header">
      <h2 className="header-title">{title}</h2>
      <div className="header-right">
        {children}
      </div>
    </div>
  );
};

export default ReusableHeader;
